import { render, staticRenderFns } from "./NotificationsDefault.vue?vue&type=template&id=e87db024&"
import script from "./NotificationsDefault.vue?vue&type=script&lang=js&"
export * from "./NotificationsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports